import { useFormik } from 'formik';
import * as Yup from "yup";

import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Button, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { createGatePassApprover, getAllApprovalStaff, getStaffByStaffType, getStaffTypes } from 'store/actions';
import { toast } from 'react-toastify';
import Spinners from 'components/Common/Spinner';
import TableContainer from 'components/Common/TableContainer';

const GatePassApprovalMapping = () => {
    const dispatch = useDispatch();
    const { staffTypeList, staffListByStaffType, loading, message, error, isCreated, approvalStaffList } = useSelector(state => state.GatePassReducer);

    const [isShowModal, setIsShowModal] = useState(false)



    const columns = useMemo(
        () => [
            {
                Header: () => <div style={{ color: "#111" }}>#</div>,
                accessor: "id",
                filterable: true,
                Cell: ({ row, rows }) => {
                    const rowIndex = rows.indexOf(row) + 1
                    return rowIndex
                },
            },
            {
                Header: () => <div style={{ color: "#111" }}>Staff Name</div>,
                accessor: "staff_name",
                filterable: true,
                Cell: ({ value }) => value || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>Staff Type</div>,
                accessor: "staff_type",
                filterable: true,
                Cell: ({ value }) => value || "",
            },

        ],
        [staffListByStaffType]
    )


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            staff_type_id: "",
            approver_staff_id: ""
        },
        validationSchema: Yup.object({
            staff_type_id: Yup.string().required("Please Select Staff Type"),
            approver_staff_id: Yup.string().required("Please Select Staff"),

        }),
        onSubmit: values => {
            console.log(values)
            dispatch(createGatePassApprover(values))
            setIsShowModal(false)
            validation.resetForm()
        },
    })

    useEffect(() => {
        dispatch(getStaffTypes())
    }, [])


    useEffect(() => {
        if (validation.values.staff_type_id) dispatch(getStaffByStaffType(validation.values.staff_type_id))

    }, [validation.values.staff_type_id])

    useEffect(() => {
        if (message) {
            toast.success(message)
        }
    }, [message])

    useEffect(() => {
        if (isCreated) {
            dispatch(getAllApprovalStaff())
        }
    }, [isCreated])

    useEffect(() => {
        dispatch(getAllApprovalStaff())
    }, [])



    return (
        <div className='page-content'>
            <div className='d-flex justify-content-between align-items-center'>
                <h6>Gate Pass Approval Mapping</h6>
                <Button onClick={() => setIsShowModal(true)} color='primary'>Create</Button>
            </div>


            {console.log(approvalStaffList)}

            {loading ? (
                <Spinners />
            ) : (
                <TableContainer
                    columns={columns}
                    data={approvalStaffList}
                    isGlobalFilter={false}
                    isAddOptions={false}
                    // handleJobClicks={handleJobClicks}
                    isJobListGlobalFilter={false}
                    isPagination={false}
                    iscustomPageSizeOptions={false}
                    isShowingPageLength={false}
                    customPageSize={100}
                    tableClass="table-bordered align-middle nowrap mt-2"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                />
            )}

            <div>
                <Modal isOpen={isShowModal} toggle={() => setIsShowModal(false)}>
                    <ModalHeader toggle={() => setIsShowModal(false)}>Create Gate Pass Approvar</ModalHeader>

                    <ModalBody>
                        <Form
                            onSubmit={e => {
                                e.preventDefault()
                                validation.handleSubmit()
                            }}>
                            <FormGroup>
                                <Label>Staff types</Label>
                                <Input
                                    name='staff_type_id'
                                    id='staff_type_id'
                                    type='select'
                                    placeholder='SELECT STAFF TYPE'
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    // disabled={isEdit}
                                    value={validation.values.staff_type_id || ""}
                                    invalid={
                                        validation.touched.staff_type_id && validation.errors.staff_type_id
                                            ? true
                                            : false
                                    }>
                                    <option>SELECT CLASS AND DIVISION</option>
                                    {staffTypeList.map((data, index) => (<option key={index} value={data.type_id}>{data.type_name}</option>))}
                                </Input>

                                {validation.touched.staff_type_id && validation.errors.staff_type_id ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.staff_type_id}
                                    </FormFeedback>
                                ) : null}

                            </FormGroup>



                            <FormGroup>
                                <Label>Staff List</Label>
                                <Input
                                    name='approver_staff_id'
                                    id='approver_staff_id'
                                    type='select'
                                    placeholder='SELECT STAFF'
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    // disabled={isEdit}
                                    value={validation.values.approver_staff_id || ""}
                                    invalid={
                                        validation.touched.approver_staff_id && validation.errors.approver_staff_id
                                            ? true
                                            : false
                                    }>
                                    <option>SELECT CLASS AND DIVISION</option>
                                    {staffListByStaffType.map((data, index) => (<option key={index} value={data.staff_id}>{data.name_list}</option>))}
                                </Input>

                                {validation.touched.approver_staff_id && validation.errors.approver_staff_id ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.approver_staff_id}
                                    </FormFeedback>
                                ) : null}

                            </FormGroup>
                            <Button type='submit' color='primary'>Submit</Button>
                        </Form>
                    </ModalBody>
                </Modal>
            </div>
        </div>
    )
}

export default GatePassApprovalMapping